import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "search-top-container flex column min-height full-height" }
const _hoisted_2 = { class: "search-bottom-container full-height min-height flex column" }

import SearchResultsPane from 'components/search/SearchResultsPane.vue';
import {useSearchStore} from 'stores/search-store';
import SearchResultDetailsPane from 'components/search/SearchResultDetailsPane.vue';
import SearchTablePane from 'components/search/SearchTablePane.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchPaneCompact',
  setup(__props) {

const searchStore = useSearchStore();


return (_ctx: any,_cache: any) => {
  const _component_q_splitter = _resolveComponent("q-splitter")!

  return (_openBlock(), _createBlock(_component_q_splitter, {
    horizontal: true,
    "model-value": _unref(searchStore).isTableModeSelected ? 100 : 35,
    limits: _unref(searchStore).isTableModeSelected ? [0, 100] : [15, 85],
    disable: _unref(searchStore).isTableModeSelected,
    class: "search-compact-container full-height min-height flex column"
  }, {
    before: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(SearchResultsPane),
        (_unref(searchStore).isTableModeSelected)
          ? (_openBlock(), _createBlock(SearchTablePane, { key: 0 }))
          : _createCommentVNode("", true)
      ])
    ]),
    after: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        (!_unref(searchStore).isTableModeSelected)
          ? (_openBlock(), _createBlock(SearchResultDetailsPane, { key: 0 }))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["model-value", "limits", "disable"]))
}
}

})